// extracted by mini-css-extract-plugin
export var headerXL = "SectionPricingCards-module--headerXL--1Fnmr";
export var headerL = "SectionPricingCards-module--headerL--1wter";
export var headerM = "SectionPricingCards-module--headerM--qI9ua";
export var headerS = "SectionPricingCards-module--headerS--14uhv";
export var headerXS = "SectionPricingCards-module--headerXS--344zE";
export var blogHeaderXL = "SectionPricingCards-module--blogHeaderXL--24dB1";
export var blogHeaderL = "SectionPricingCards-module--blogHeaderL--1A0O1";
export var blogHeaderM = "SectionPricingCards-module--blogHeaderM--2PCmq";
export var blogHeaderS = "SectionPricingCards-module--blogHeaderS--1DDjm";
export var blogHeaderXS = "SectionPricingCards-module--blogHeaderXS--3y_jy";
export var headerPreamble = "SectionPricingCards-module--headerPreamble--3UKJL";
export var preHeader = "SectionPricingCards-module--preHeader--26HWA";
export var textNormal = "SectionPricingCards-module--textNormal--2cJUo";
export var textSmall = "SectionPricingCards-module--textSmall--3f6u8";
export var textSmallAlternate = "SectionPricingCards-module--textSmallAlternate--1Ub2B";
export var legend = "SectionPricingCards-module--legend--3C_ci";
export var caption = "SectionPricingCards-module--caption--37jO6";
export var gradientBackground = "SectionPricingCards-module--gradientBackground--1klOS";
export var ellipsis = "SectionPricingCards-module--ellipsis--lpDW4";
export var globalContainer = "SectionPricingCards-module--globalContainer--2VcxI";
export var maxWidth = "SectionPricingCards-module--maxWidth--2eMW1";
export var clipBottom = "SectionPricingCards-module--clipBottom--3otzU";
export var clipTopBottom = "SectionPricingCards-module--clipTopBottom--3iEh4";
export var pricingSection = "SectionPricingCards-module--pricingSection--3eKZY";
export var pricingCard = "SectionPricingCards-module--pricingCard--2UQqD";
export var content = "SectionPricingCards-module--content--3Xq37";
export var title = "SectionPricingCards-module--title--3sZMv";
export var price = "SectionPricingCards-module--price--3F8qs";
export var description = "SectionPricingCards-module--description--1fOC2";
export var bottomButton = "SectionPricingCards-module--bottomButton--3oKBG";
export var ch2 = "SectionPricingCards-module--ch2--3jYUd";
export var ch2Container = "SectionPricingCards-module--ch2-container--2kfka";